import { COPYRIGHT_ENGLISH } from "../constants.js";
export const es = {
    "Notice": "Notice",
    "No slots available for the selected period.": "No slots available for the selected period.",
    "welcome_back": "Bienvenido de nuevo",
    "login_subtitle": "Por favor inicie sesión para continuar.",
    "login_tos_prefix": "Al iniciar sesión acepta nuestros",
    "terms_of_service": "Términos de servicio",
    "help": "Ayuda",
    "privacy": "Privacidad",
    "imprint": "Aviso legal",
    "or": "o",
    "google": "Google",
    "sso_icon_alt": "Icono SSO",
    "SSO": "SSO",
    "these_zesty_duck_nudge": "Información básica",
    "north_least_gopher_burn": "¿Cuál es el propósito de este tipo de cita?",
    "lazy_just_duck_spin": "Título del evento",
    "Confirm meeting": "Confirmar reunión",
    "Meeting with {{name}}": "Reunión con {{name}}",
    "Daily availability": "Disponibilidad diaria",
    "tiny_factual_platypus_pave": "¿Dónde tendrá lugar la reunión?",
    "less_equal_octopus_dine": "Parte personalizable de la URL",
    "quiet_male_yak_slurp": "Slug del evento",
    "honest_weak_iguana_rest": "Ubicación",
    "dizzy_quiet_walrus_hush": "reunion-increible",
    "tired_whole_bumblebee_type": "Reunión de Zoom",
    "these_moving_fox_create": "Descripción",
    "quaint_known_wasp_view": "Días mínimos de antelación",
    "pretty_grand_cuckoo_arrive": "Los eventos no se pueden programar con menos de este tiempo de antelación",
    "slow_maroon_spider_praise": "Número máximo de eventos de este tipo por día",
    "grand_wacky_ox_flow": "Máximo por día",
    "left_aloof_stork_leap": "búfer-antes",
    "elegant_early_boar_accept": "¿Cuánto dura este evento?",
    "ideal_this_coyote_inspire": "Duración",
    "jumpy_tasty_rook_trust": "Duración",
    "real_big_crow_push": "Búfer antes de este evento",
    "mealy_happy_ray_flop": "Búfer antes",
    "close_actual_deer_boil": "Búfer después",
    "keen_zippy_bulldog_gaze": "Búfer después de este evento",
    "seemly_fine_octopus_slurp": "Disponibilidad",
    "each_awake_tadpole_jest": "Editar tipo de evento",
    "extra_patient_warbler_praise": "No hay eventos para reservar",
    "petty_swift_piranha_rise": "Programar evento",
    "broad_close_butterfly_drop": "Programar una cita con {{name}}",
    "weary_known_gazelle_file": "Por favor, seleccione el tipo de cita que necesita y haga clic en el botón de programación para reservarla. Obtendrá una lista de espacios disponibles en mi horario.",
    "low_clean_haddock_bubble": "Mis tipos de eventos",
    "My Event Types": "Mis tipos de eventos",
    "pink_trite_ocelot_enrich": "¡Primero debe conectar su calendario antes de poder agregar eventos!",
    "early_sweet_mantis_peek": "Agregar tipo de evento",
    "deft_suave_bear_pause": "Cargando",
    "equal_jolly_thrush_empower": " minutos",
    "Schedule an appointment": "Programar una cita",
    "heroic_kind_llama_zip": "Atrás",
    "awake_jolly_gazelle_lock": "Omitir",
    "whole_acidic_parrot_promise": "Reservar cita",
    "clear_close_racoon_pat": "{{value, dateTime}}",
    "cuddly_spare_felix_stir": "Paso {{val}}",
    "extra_misty_panda_grip": "Los usuarios pueden usar este enlace para reservar citas.",
    "sunny_great_halibut_empower": "Crear el primero",
    "create_first_event_type_button": "Tipo de evento",
    "application_title": "Appoint Me",
    "orange_grand_racoon_fall": "Cómo funciona {{app_title}}",
    "male_patient_hedgehog_ask": "{{app_title}} es un sistema de reserva de citas simple y fácil de usar. Le permite crear eventos, compartir su enlace y permitir que los usuarios reserven citas con usted.",
    "factual_moving_hawk_belong": "Especifique dónde agrega {{app_title}} sus citas y dónde verifica si está ocupado.",
    "step_1_configure_calendars": "Paso 1: Configurar calendarios",
    "pink_polite_racoon_earn": "Paso 2: Crear eventos",
    "happy_wise_mantis_laugh": "\"¡Agregue sus horarios disponibles y listo!\"",
    "careful_misty_bullock_splash": "Paso 3: Compartir su enlace",
    "game_frail_vole_treasure": "¡Hecho! ¡Felicidades!",
    "still_helpful_koala_trust": "Una vez que un usuario reserva una cita, el evento se agrega a su calendario.",
    "steep_fine_lobster_inspire": "Error al guardar el tipo de evento",
    "best_due_parakeet_zip": "¡Tipo de evento creado!",
    "happy_caring_fox_spur": "Evento guardado",
    "tasty_witty_stingray_hope": "Error al guardar el evento",
    "trite_warm_gorilla_pet": "Agregar citas al calendario",
    "aware_alert_mare_glow": "Verificar tiempo libre en calendarios",
    "factual_nimble_snail_clap": "Guardar cambios",
    "tiny_teary_clownfish_vent": "Cancelar",
    "lower_born_finch_dash": "Desconectar de Google",
    "whole_formal_liger_rise": "Conectar Google Calendar",
    "pink_loose_cougar_grin": "Mi calendario",
    "upper_even_florian_peek": "Google Calendar",
    "merry_north_meerkat_cuddle": "Configuración",
    "big_known_loris_revive": "Elija calendarios para verificar las horas ocupadas.",
    "large_suave_gull_hush": "copiar enlace",
    "misty_proud_mallard_assure": "Copiar enlace",
    "teal_lofty_hawk_peek": "Cancelar",
    "mild_raw_elk_delight": "Guardar cambios",
    "Choose date": "Elegir fecha",
    "Please select a date": "Por favor seleccione una fecha",
    "Choose time": "Elegir hora",
    "Provide details": "Proporcionar detalles",
    "Confirmation": "Confirmación",
    "Please share anything that will help me to prepare for our meeting": "Por favor, comparta cualquier cosa que me ayude a prepararme para nuestra reunión",
    "confirmationText_male": "Ha reservado una cita {{event}} con {{name}} el {{date}} a las {{time}}.",
    "confirmationText_female": "Ha reservado una cita {{event}} con {{name}} el {{date}} a las {{time}}.",
    "confirmationText_neuter": "Ha reservado una cita {{event}} con {{name}} el {{date}} a las {{time}}.",
    "Name": "Nombre",
    "Please provide your name": "Por favor proporcione su nombre",
    "Email": "Correo electrónico",
    "Information": "Información",
    "You will receive a confirmation email": "Recibirá un correo electrónico de confirmación",
    "Meeting with": "Reunión con",
    "Change": "Cambiar",
    "Back": "Atrás",
    "Add Event Type": "Agregar tipo de evento",
    "Confirm & Book": "Confirmar y reservar",
    "availableSlots": "Los siguientes espacios están disponibles el {{date}}. Reserve uno o elija otro día.",
    "minutes": "minutos",
    "Days": "Días",
    "Maximum days in advance": "Días máximos de antelación",
    "event_advance_availability_description": "¿Con cuántos días de antelación está disponible este tipo de evento?",
    "none": "Ninguno",
    "Select buffer": "Seleccionar búfer",
    "Save": "Guardar",
    "Select duration": "Seleccionar duración",
    "Starttime": "Hora de inicio",
    "Endtime": "Hora de finalización",
    "Add Account": "Agregar cuenta",
    "Add CalDav Account": "Agregar cuenta CalDav",
    "CalDav Accounts": "Cuentas CalDav",
    "Server URL": "URL del servidor",
    "Username": "Nombre de usuario",
    "label_password": "Contraseña",
    "send_invitation_email": "Send invitation email",
    "send_invitation_email_notice": "Only needed if your CalDAV server does not send invitations automatically.",
    "invitationSubject": "Invitación: {{summary}}",
    "invitationBody": "<p>Hola {{attendeeName}},</p><p>Has sido invitado al siguiente evento:</p><h3>{{summary}}</h3><p>{{description}}</p><p><strong>Hora:</strong> {{time}}</p><p>Por favor, encuentre los detalles del evento adjuntos.</p>",
    "icsDescription": "Descripción del evento:\n{{description}}",
    "dateFormat": "es-ES",
    "user_menu_log_out": "Cerrar sesión",
    "user_menu_log_in": "Iniciar sesión",
    "user_menu_profile": "Perfil",
    "user_menu_my_account": "Mi cuenta",
    "user_menu_calendar_integration": "Integración de calendario",
    "user_menu_copy_link": "Copiar tu enlace",
    "user_menu_link_copied": "Enlace copiado",
    "name": "Nombre",
    "user_url": "URL de usuario",
    "use_gravatar": "Usar Gravatar",
    "save": "Guardar",
    "profile_updated": "Perfil actualizado correctamente",
    "error_saving_profile": "Error al guardar el perfil",
    "user_url_taken": "URL de usuario ya en uso",
    "error_loading_profile": "Error al cargar el perfil",
    "login_with_sso": "Iniciar sesión con SSO",
    "login_with": "Iniciar sesión con",
    "login_successful": "Inicio de sesión exitoso",
    "login_failed": "Inicio de sesión fallido",
    "google_login_failed": "Fallo en el inicio de sesión de Google",
    "Add": "Añadir",
    "edit": "Editar",
    "Close": "Cerrar",
    "Choose calendars in which appointments are created.": "Elija los calendarios en los que se crean las citas.",
    "Email (Optional)": "Correo electrónico (Opcional)",
    "Enter your CalDav server details to connect your calendar.": "Ingrese los detalles de su servidor CalDav para conectar su calendario.",
    "Failed to add account. Please check your credentials and server URL.": "No se pudo agregar la cuenta. Verifique sus credenciales y la URL del servidor.",
    "I acknowledge that my password will be stored encrypted in the database.": "Reconozco que mi contraseña se almacenará cifrada en la base de datos.",
    "event_copy_link": "Copiar enlace",
    "link_copied_to_clipboard": "¡Enlace copiado al portapapeles!",
    "link_copy_failed": "¡No se pudo copiar el enlace al portapapeles!",
    "copy": "Copiar",
    "Availability Mode": "Modo de disponibilidad",
    "Define Custom": "Definir personalizado",
    "Use Standard": "Usar estándar",
    "Standard + Extra": "Estándar + Extra",
    "Standard + Constraints": "Estándar + Restricciones",
    "Standard Availability": "Disponibilidad estándar",
    "Using Standard Availability defined in Profile settings.": "Usando la disponibilidad estándar definida en la configuración del perfil.",
    "Define your standard weekly availability here. You can use this availability in your Event Types.": "Defina aquí su disponibilidad semanal estándar. Puede utilizar esta disponibilidad en sus tipos de eventos.",
    "Copy Standard Availability": "Copiar disponibilidad estándar",
    "Overwrite current availability with standard?": "¿Sobrescribir la disponibilidad actual con la estándar?",
    "Profile": "Perfil",
    "about": "Acerca de",
    "about_content": "# Acerca de AppointMe\n\nAppointMe es una herramienta sencilla para la programación de citas.\nConfigura tus calendarios, establece tu disponibilidad y permite que otros reserven citas contigo.\n\n## Github\n[Mira el código en Github](https://github.com/fhswf/appointme)\n\n## Créditos\nImplementado con ❤️ en la Universidad de Ciencias Aplicadas de South Westphalia",
    "legal": "Aviso legal",
    "Calendar": "Calendario",
    "Select a calendar": "Seleccionar un calendario",
    "No calendar selected": "Ningún calendario seleccionado",
    "Calendar settings saved": "Configuración del calendario guardada",
    "Failed to save settings": "Error al guardar la configuración",
    "Failed to load calendars for": "Error al cargar calendarios para",
    "Google Calendar disconnected": "Google Calendar desconectado",
    "Failed to disconnect Google Calendar": "Error al desconectar Google Calendar",
    "Connect a calendar to get started": "Conecta un calendario para empezar",
    "Online via Zoom": "En línea vía Zoom",
    "Language": "Idioma",
    "page not found": "Página no encontrada",
    "GO HOME": "INICIO",
    "Impressum": "Aviso legal",
    "Datenschutzhinweise": "Política de privacidad",
    "privacy_content": `
# Política de privacidad

## Recopilación y uso de datos
Esta aplicación recopila y utiliza datos personales para proporcionar servicios de programación de citas.

*   **Perfil de usuario:** Almacenamos su nombre, dirección de correo electrónico y foto de perfil para identificarlo y personalizar su experiencia.
*   **Datos de usuario de Google:** Si conecta su Google Calendar, accedemos a los datos de su calendario para:
    *   Verificar su disponibilidad para evitar reservas dobles.
    *   Crear nuevos eventos en su calendario cuando se reserva una cita.
    *   **No** utilizamos sus datos de Google Calendar para ningún otro propósito, como publicidad o investigación de mercado.
*   **Datos del calendario:** Almacenamos la configuración de sus calendarios conectados, los tipos de eventos que crea (nombre, descripción, ubicación) y las reservas de citas.
*   **Datos de registro:** Su dirección IP se almacena temporalmente en los archivos de registro del servidor para fines de seguridad y solución de problemas.
*   **Telemetría:** Recopilamos datos de uso anónimos e informes de errores utilizando Sentry para mejorar la estabilidad de la aplicación.

## Intercambio de datos
No compartimos sus datos personales con terceros, excepto cuando sea necesario para proporcionar el servicio o lo exija la ley.

*   **Datos de usuario de Google:** Los datos obtenidos de las API de Google **no se comparten** con herramientas de terceros, modelos de IA o entidades externas, excepto cuando sea necesario para proporcionar las funciones de integración del calendario (por ejemplo, comunicarse con los servidores de Google).
*   **Proveedores de servicios:** Utilizamos Sentry para el seguimiento de errores y la supervisión de aplicaciones para garantizar la estabilidad del servicio. Este proveedor puede procesar direcciones IP y otros datos técnicos estrictamente para la prestación del servicio.
*   **Alojamiento:** La aplicación está alojada en nuestra propia infraestructura (clúster de Kubernetes). No utilizamos CDN de terceros ni proveedores de alojamiento que, por lo tanto, obtengan acceso a sus datos.

## Almacenamiento y protección de datos
Sus datos se almacenan de forma segura en nuestros servidores.
*   **Cifrado:** Todos los datos transmitidos entre su navegador y nuestros servidores están cifrados mediante HTTPS. Los datos confidenciales, como los tokens de acceso, se almacenan cifrados en nuestra base de datos.
*   **Control de acceso:** El acceso a sus datos está restringido al personal autorizado y solo se accede cuando es necesario para soporte o mantenimiento.

## Retención y eliminación de datos
*   **Retención:** Conservamos su perfil de usuario y los datos de configuración del calendario mientras su cuenta esté activa. Los datos de las citas se conservan para proporcionarle un historial de sus eventos programados.
*   **Eliminación:** Tiene derecho a solicitar la eliminación de sus datos. Puede desconectar su Google Calendar en cualquier momento a través de la configuración de la aplicación, lo que eliminará nuestro acceso a sus datos de Google. Para solicitar la eliminación completa de la cuenta y los datos, contáctenos en gawron.christian@fh-swf.de o utilice la función de eliminación de cuenta en la configuración de su perfil.

## Política de datos de usuario de los servicios de API de Google
El uso y la transferencia por parte de AppointMe a cualquier otra aplicación de la información recibida de las API de Google cumplirán con la [Política de datos de usuario de los servicios de API de Google](https://developers.google.com/terms/api-services-user-data-policy), incluidos los requisitos de uso limitado.`,
    "privacy_content_public": `
# Política de privacidad

## Procesamiento de datos

Con el fin de reservar una cita, esta aplicación procesa los datos que usted proporciona (nombre, dirección de correo electrónico, descripción, fecha y hora de la cita). Estos datos se almacenan para gestionar la cita y pueden sincronizarse con el calendario del organizador.

## Telemetría

Utilizamos Sentry para recopilar datos de telemetría anónimos e informes de errores para mejorar la estabilidad de la aplicación.`,
    "impressum_content": "# Aviso legal\n\n## Descargo de responsabilidad\nEl contenido de este servidor no forma parte de la oferta en línea oficial de la Universidad de Ciencias Aplicadas de South Westphalia.",
    "CalDav Calendar": "Calendario CalDav",
    "loading": "Cargando...",
    "Legal": "Aviso legal",
    "new_event_type": "Nuevo tipo de evento",
    "Appointment Summary": "Resumen de la cita",
    "Could not book event": "No se pudo reservar el evento",
    "error_no_calendar": "No se configuró ninguna integración de calendario",
    "error_no_duration": "La duración debe ser mayor a 0",
    "error_no_slots": "No hay franjas horarias configuradas",
    "Active": "Activo",
    "Inactive": "Inactivo",
    "delete": "Eliminar",
    "Continue": "Continuar",
    "Book Appointment": "Reservar cita",
    "Available Times": "Horarios disponibles",
    "No slots available": "No hay horarios disponibles",
    "Schedule Appointment": "Programar cita",
    "Available Meeting Types": "Tipos de reunión disponibles",
    "Please select a meeting type to view availability.": "Seleccione un tipo de reunión para ver la disponibilidad.",
    "All": "Todos",
    "No public events found.": "No se encontraron eventos públicos.",
    "Timezone": "Zona horaria",
    "Privacy & Terms": "Privacidad y Términos",
    "Quick": "Rápida",
    "Consulting": "Consultoría",
    "Tags": "Etiquetas",
    "Type a tag and press Enter": "Escribe una etiqueta y presiona Enter",
    "Press Enter to add a tag": "Presiona Enter para agregar una etiqueta",
    "Cancel": "Cancelar",
    "landing_hero_title": "Appointment management <span class=\"text-primary\">made easy</span>",
    "landing_hero_subtitle": "Appoint Me is a simple and user-friendly solution for your appointments. Create events, share your link, and let others book appointments with you.",
    "landing_cta_start": "Start now",
    "landing_cta_learn_more": "Learn more",
    "landing_how_it_works_title": "How Appoint Me works",
    "landing_how_it_works_subtitle": "In just four simple steps to your organized calendar.",
    "landing_step1_title": "1. Configure calendar",
    "landing_step1_desc": "Determine where Appoint Me should enter appointments and where your availability should be checked. Connect your Google or Outlook calendar.",
    "landing_step2_title": "2. Create events",
    "landing_step2_desc": "Add your available times, define duration and break times, and get started!",
    "landing_step3_title": "3. Share your link",
    "landing_step3_desc": "Via your personal link, customers, colleagues, or friends can book appointments directly without annoying email ping-pong.",
    "landing_step4_title": "Done! Congrats!",
    "landing_step4_desc": "As soon as a user books an appointment, the event is automatically added to your calendar and both receive a confirmation.",
    "landing_footer_product": "Product",
    "landing_footer_features": "Features",
    "landing_footer_pricing": "Pricing",
    "landing_footer_integrations": "Integrations",
    "landing_footer_resources": "Resources",
    "landing_footer_documentation": "Documentation",
    "landing_footer_api": "API",
    "landing_footer_help_center": "Help Center",
    "landing_footer_legal": "Legal",
    "landing_footer_imprint": "Imprint",
    "landing_footer_privacy": "Privacy",
    "landing_footer_terms": "Terms & Conditions",
    "landing_footer_copyright": COPYRIGHT_ENGLISH,
    "landing_footer_tagline": "Simple appointment planning for everyone.",
    "Contact": "Contacto",
    "footer_credits": "Programado con ❤️ en la Universidad de Ciencias Aplicadas de South Westphalia",
    "terms_of_use_title": "Terms of Use",
    "terms_of_use_content": "# Terms of Use\n\n## Service Provision\n\nThis service is provided free of charge.\n\n## Disclaimer of Liability and Warranty\n\nNeither the authors nor the South Westphalia University of Applied Sciences accept any liability for damages of any kind or any warranty of any kind in connection with the use of this service. Use is at your own risk. This disclaimer does not apply to damages resulting from injury to life, body, or health based on an intentional or negligent breach of duty, nor to other damages based on an intentional or grossly negligent breach of duty.",
    "my_appointments": "Mis Citas",
    "no_upcoming_appointments": "No se encontraron citas próximas.",
    "appointment": "Cita",
    "attendee": "Asistente",
    "appointment_details": "Detalles de la Cita",
    "close": "Cerrar",
    "event_type": "Tipo de Evento",
    "week": "Semana",
    "work_week": "Semana Laboral",
    "day": "Día",
    "month": "Mes",
    "today": "Hoy",
    "agenda": "Agenda",
    "more": "más",
    "next": "Siguiente",
    "back": "Atrás",
    "n_more": "{{count}} más ...",
    "Recurrence": "Recurrencia",
    "Enable Recurring Event": "Habilitar evento recurrente",
    "Frequency": "Frecuencia",
    "Weekly": "Semanal",
    "Bi-weekly": "Quincenal",
    "Tri-weekly": "Cada 3 semanas",
    "Monthly": "Mensual",
    "End Condition": "Condición de finalización",
    "Occurrences": "Ocurrencias",
    "OR": "O",
    "Until Date": "Hasta la fecha",
    "Time Span": "Lapso de tiempo",
    "Months": "Meses",
    "Weeks": "Semanas",
    "Recurring Event": "Evento recurrente",
    "Recurring": "Recurrente",
    "weekly": "Semanal",
    "biweekly": "Quincenal",
    "triweekly": "Cada 3 semanas",
    "monthly": "Mensual",
    "Series Booking Note: Students will book all occurrences at once.": "Nota de reserva en serie: Los estudiantes reservarán todas las ocurrencias a la vez.",
    "Feedback": "Comentarios",
    "Student Only": "Solo estudiantes",
    "Restricted to Students": "Restringido a estudiantes",
    "Settings exported successfully": "Configuración exportada con éxito",
    "Failed to export settings": "Error al exportar la configuración",
    "Are you sure you want to import settings? This will overwrite your current profile and events.": "¿Está seguro de que desea importar la configuración? Esto sobrescribirá su perfil y eventos actuales.",
    "Settings imported successfully": "Configuración importada con éxito",
    "Failed to import settings": "Error al importar la configuración",
    "Invalid file format": "Formato de archivo no válido",
    "Data": "Datos",
    "Export Settings": "Exportar configuración",
    "Download your settings and events as a JSON file.": "Descargue su configuración y eventos como un archivo JSON.",
    "Export Data": "Exportar datos",
    "Import Settings": "Importar configuración",
    "Restore your settings from a JSON file. This will overwrite existing data.": "Restaure su configuración desde un archivo JSON. Esto sobrescribirá los datos existentes.",
    "Select File": "Seleccionar archivo",
    "Online Meeting": "Reunión en línea",
    "You are logged in via your Learning Management System. Please use the specific booking links provided in your course to book appointments.": "Ha iniciado sesión a través de su sistema de gestión de aprendizaje. Utilice los enlaces de reserva específicos proporcionados en su curso para reservar citas.",
    "Logout": "Cerrar sesión",
    "MyProvider": "Mi proveedor",
    "Grammatical Gender": "Género gramatical",
    "Male": "Masculino",
    "Female": "Femenino",
    "Neuter": "Neutro",
    "gender_help_text": "Utilizado para la gramática correcta en los mensajes de confirmación.",
    "Changelog": "Changelog",
    "Failed to load changelog data.": "No se pudieron cargar los datos del registro de cambios.",
    "See what's new and what has been fixed.": "Vea qué hay de nuevo y qué se ha corregido.",
    "Reminder setting": "Configuración de recordatorio",
    "Notification type": "Tipo de notificación",
    "System notification": "Notificación del sistema",
    "No reminder": "Sin recordatorio",
    "Reminder time": "Hora del recordatorio",
    "Reminder settings saved": "Configuración de recordatorio guardada",
    "At event start": "Al inicio del evento",
    "minutes before": "minutos antes",
    "1 day before": "1 día antes",
    "days before": "días antes",
    "1 hour before": "1 hora antes",
    "hours before": "horas antes"
};
//# sourceMappingURL=es.js.map